/**
 * « Tarifs spécifiques sur les paliers de durée » (bowling) — miroir d'affichage de
 * PrestationService::uniformPricePerPerson (app/Helpers/PrestationService.php).
 *
 * Sert uniquement à réévaluer en direct, pendant la saisie, si le switch des tarifs spécifiques
 * peut être activé. La décision appartient au serveur (storePlanning, Step5Request) : ce calcul
 * n'est qu'un confort d'interface.
 */

const TOLERANCE = 0.005

const toNumber = (value) => {
    const number = parseFloat(value)
    return Number.isFinite(number) ? number : 0
}

/**
 * Prix par personne commun à la base, aux options et à leurs paliers, ou null.
 *
 * @param {Array} tarifs Options de Step5 : [{ price, prices_degressif: [{ persons, price }] }]
 * @param {boolean} perGroup Mode « tarif par groupe » : un palier est un forfait (prix ÷ effectif).
 * @param {number|string|null} basePrice Prix de base de la prestation (1ʳᵉ option).
 * @returns {number|null}
 */
export function uniformPricePerPerson(tarifs, perGroup, basePrice = null) {
    const options = Array.isArray(tarifs) ? tarifs : []
    if (options.length === 0) return null

    const prices = basePrice === null || basePrice === '' || basePrice === undefined ? [] : [toNumber(basePrice)]

    options.forEach((option) => {
        prices.push(toNumber(option?.price))
        ;(option?.prices_degressif || []).forEach((tier) => {
            const tierPrice = toNumber(tier?.price)
            const persons = parseInt(tier?.persons, 10) || 0
            // Palier à 0 € = « non renseigné » : l'option s'applique, il ne compte pas.
            if (tierPrice <= 0 || persons < 1) return
            prices.push(perGroup ? tierPrice / persons : tierPrice)
        })
    })

    const reference = prices[0]
    if (!(reference > 0)) return null

    return prices.every((price) => Math.abs(price - reference) <= TOLERANCE) ? reference : null
}
